import { getLanguageAwareURL } from "./get-language-aware-url";
import { LANGUAGES } from "./constants";

export interface AlternateLang {
    hrefLang: string;
    href: string;
}

export function getLanguageAlternates(
    currentPath: string
): AlternateLang[] {
    const alternateLangs: AlternateLang[] = [
        LANGUAGES.SPANISH,
        LANGUAGES.ENGLISH,
    ].map((lang) => ({
        hrefLang: lang,
        href: getLanguageAwareURL(currentPath, lang),
    }));

    alternateLangs.push({
        hrefLang: 'x-default',
        href: getLanguageAwareURL(
            currentPath,
            process.env.NEXT_PUBLIC_DEFAULT_LANG
        ),
    });

    return alternateLangs;
}